export const CONTAINER_CONST = {
    OTA_DETAILS_ACTIVE: "OTA_DETAILS_ACTIVE",
    OTA_UPLOAD_ACTIVE: "OTA_UPLOAD_ACTIVE",
    IP_LOG_UPLOAD_ACTIVE: "IP_LOG_OTA_UPLOAD_ACTIVE",
    SYSTEM_HEALTH_ACTIVE: "SYSTEM_HEALTH_ACTIVE",
    REQUEST_CALLBACK: "REQUEST_CALLBACK",
    DEMO_MACHINE: "DEMO_MACHINE",
    HOSPITAL_DASHBOARD: "HOSPITAL_DASHBOARD",
    DEVICE_DOCUMENTS: "DEVICE_DOCUMENTS",
};

export const PAGE_CONST = {
    HOME: "HOME",
    MACHINE_VERSION_UPDATE_DETAILS: "MACHINE_VERSION_UPDATE_DETAILS",
    MACHINE_DETAILS: "MACHINE_DETAILS",
    
    IP_LOG: "IP_LOG",
    LOGIN: "LOGIN",
    PREUSE: "PREUSE"
};

export const BUTTON_CONST = {
    UPDATE_SYSTEM_BUTTON: "UPDATE_SYSTEM_BUTTON",
}

export const TIMELINE_CONST = {
    DATE_TIME_FORMAT: "DD-MM-YYYY HH:mm",
    DATE_FORMAT: "DD-MM-YYYY",
    TIME_FORMAT: "HH:mm:ss"
};

export const ACTIVE_DEVICE = {
    V730i:"V730i",
    NX5:"NX5"
}

export const ENV = {
    ENV_PROD:"Prod",
    ENV_TEST:"Test"
}